module.exports = __webpack_public_path__ + "static/media/icn_collections_big.b0679a7f.svg";